import { styled, TableHead } from '@mui/material';

const StyledTableHead = styled(TableHead)`
  & .MuiTableCell-root {
    background-color: white;
  }
`;

export default StyledTableHead;
